import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Alert, Spinner, Row, Col, Button, ProgressBar } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { Helmet } from 'react-helmet';
import Episode from '../../components/Episode';
import { settings } from '../../config/settings';
import { LoginManager } from '../../core/login-manager';
import { ApiManager } from '../../core/api-manager';
import moment from 'moment';
import { ZoomMtg } from '@zoom/meetingsdk';



export default function Zoom() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const { k } = useParams();
    const id = parseInt(k)

    const [data, setData] = useState(null);
    const [idSession, setIdSession] = useState(null);
    const [intervalSeconds, setIntervalSeconds] = useState(5);
    const [crono, setCrono] = useState(0);
    const userInfo = LoginManager.getUserInfo();

    const [meetingData, setMeetingData] = useState(null);


    useEffect(() => {
        init()
    }, [id]);

    useEffect(() => {
        if (data) {
            getUserStats()
            initMeeting()
        }
    }, [data]);


    async function init() {
        var response = await DataManager.getItem('episode', id)
        if (response.success === 1) {
            if (response.body.length) {
                var t = response.body[0]
                console.warn('episodio', t)
                setData(t)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
                setData({})
            }
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }


    const [episodesStats, setEpisodesStats] = useState(null);
    async function getUserStats() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [
            {
                "fieldName": "idEpisode",
                "type": "value",
                "value": data.id
            },
            {
                "fieldName": "author",
                "type": "value",
                "value": userInfo.id
            }
        ]
        var response = await DataManager.searchItems('episode_user', 1, 1, sorting, '', [], constraints)
        if (response.success === 1 && response.body.length > 0) {
            setEpisodesStats(response.body[0])
        }
        else {
            console.warn(response)
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setCrono(crono => crono + intervalSeconds);
        }, (intervalSeconds * 1000));

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (crono !== 0) {
            saveEpisodeTime()
        }
    }, [crono]);


    async function saveEpisodeTime() {
        if (id) {
            const now = new Date();
            const episodeDate = new Date(data.episodeDate)

            if (now > episodeDate) {

                console.warn('idSession', idSession)
                if (idSession) {
                    var body = {
                        idEpisodeUser: null,
                        dateStart: null,
                        dateEnd: moment().format('YYYY-MM-DD HH:mm:ss'),
                        idSession: parseInt(idSession),
                        device: null,
                        userAgent: null,
                        type: null
                    }
                    var res = await ApiManager.sendAuthenticatedRequest('/custom/create_record_session', body);
                    if (res.success === 1) {
                        console.log("Aggiornato con successo!", res)
                    } else {
                        console.log("UPDATE -- Errore!", res)
                    }
                } else {
                    if (episodesStats) {
                        var body = {
                            idSession: null,
                            idEpisodeUser: episodesStats.id,
                            dateStart: moment().format('YYYY-MM-DD HH:mm:ss'),
                            dateEnd: moment().format('YYYY-MM-DD HH:mm:ss'),
                            type: data && data.type.value === "video" ? "10_VIDEO" : data && data.type.value === "live" ? "0_LIVE" : data && data.type.value === "survey" ? "20_SURVEY" : data && data.type.value === "file" ? "30_FILE" : null,
                            device: window.innerWidth < 768 ? "0_MOBILE" : "10_DESKTOP",
                            userAgent: window.navigator.userAgent
                        }
                        var res = await ApiManager.sendAuthenticatedRequest('/custom/create_record_session', body);
                        if (res.success === 1) {
                            console.log("Inserito con successo!", res)
                            setIdSession(parseInt(res.id))
                        } else {
                            console.log("INSERT -- Errore!", res)
                        }
                    }
                }

                if (episodesStats) {

                    console.warn('episodesStats', episodesStats, 'data', data)
                    // aggiorno episode user
                    if (data.percentage) {
                        var totalTime = data.estimatedMinutes * 60 * data.percentage / 100
                    }
                    else {
                        var totalTime = data.estimatedMinutes * 60
                    }
                    if (totalTime < episodesStats.time + intervalSeconds) {
                        var responseUser = await LoginManager.updateProfile({ points: data.points });
                        var body = {
                            'time': episodesStats.time + intervalSeconds,
                            'isCompleted': 1
                        }
                    }
                    else {
                        var body = {
                            'time': episodesStats.time + intervalSeconds
                        }
                    }
                    var response = await DataManager.updateItem('episode_user', body, episodesStats.id);
                    if (response.success === 1) {
                        getUserStats()
                    }

                }
                else {
                    var body = {
                        'idEpisode': id,
                        'idCourse': data.idCourse.id,
                        'time': intervalSeconds
                    }
                    var response = await DataManager.insertItem('episode_user', body);
                    if (response.success === 1) {
                        console.log(response)
                        getUserStats()
                    }
                }
            }
        }
    }


    const clientId = "EaDQBGaCTiGvLoxYYcdyaQ";
    const clientSecret = "2QNeL7ss2AC5uZpprsmcRG5J911EiUiB";
    const KJUR = require('jsrsasign');
    const [started, setStarted] = useState(false);




    async function initMeeting() {
        if (data && data.idLive) {
            var response = await DataManager.getItem('episode_live', data.idLive)
            console.warn('episode_live', response)
            if (response.success === 1) {
                let b = response.body[0]
                console.log(b)
                setMeetingData(b)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
            }
        }
    }

    async function generateSignature(key, secret, meetingNumber, role) {
        const iat = Math.round(new Date().getTime() / 1000) - 180
        const exp = iat + 60 * 60 * 2
        const oHeader = { alg: 'HS256', typ: 'JWT' }

        const oPayload = {
            sdkKey: key,
            appKey: key,
            mn: meetingNumber,
            role: role,
            iat: iat,
            exp: exp,
            tokenExp: exp
        }

        const sHeader = JSON.stringify(oHeader)
        const sPayload = JSON.stringify(oPayload)
        const sdkJWT = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, secret)
        return sdkJWT
    }

    async function initZoom(meetingNumber, password) {
        var signature = await generateSignature(clientId, clientSecret, meetingNumber, 0);
        console.warn(signature)


        ZoomMtg.preLoadWasm()
        ZoomMtg.prepareWebSDK()

        ZoomMtg.i18n = ZoomMtg.i18n.load('it-IT')

        ZoomMtg.init({
            leaveUrl: "https://elibrary.fedespedi.it/episodi/" + id,
            patchJsMedia: true,
            defaultView: "gallery",
            screenShare: false,
            videoDrag: false,
            success: (success) => {
                console.log('SDK initialized successfully')

                ZoomMtg.join({
                    sdkKey: clientId,
                    signature: signature,
                    meetingNumber: meetingNumber,
                    userName: userInfo.name + ' ' + userInfo.surname,
                    userEmail: userInfo.email,
                    passWord: password,
                    success: (success) => {
                        console.log('Joined meeting successfully')
                    },
                    error: (error) => {
                        console.error('Failed to join meeting:', error)
                    }
                })
            },
            error: (error) => {
                console.error('Failed to initialize SDK:', error)
            }
        })

        setStarted(true)
    }


    useEffect(() => {
        if (meetingData !== null) {
            goToMeeting(meetingData)
        }
    }, [meetingData]);


    async function goToMeeting(item) {
        if (item.meetingNumber) {
            initZoom(item.meetingNumber, item.password)
        }
        else {
            window.open(item.link, '_blank'); // mando utente a link meeting
        }
    }



    if (data) {
        if (data.name) {

            return (
                <>
                    <Helmet>
                        <title>{data.name}</title>
                    </Helmet>

                    <Container fluid style={{ backgroundColor: 'var(--primary-color)' }} className='p-0'>
                        <div className=''>
                            <Container fluid='md' className=' mb-5 text-light py-5'>

                                {errors.length > 0 &&
                                    <Alert variant='danger'>
                                        {errors}
                                    </Alert>
                                }
                                <Button style={{ border: 0, color: 'white', backgroundColor: 'transparent' }} className='mb-5' onClick={() => window.history.go(-1)}><FontAwesomeIcon icon='arrow-left' className='me-2'></FontAwesomeIcon>{LanguageProvider.get('defaults.back')}</Button>
                                <h4>{data.idCourse.name}</h4>
                                <h2>{data.name}</h2>

                            </Container>
                        </div>
                    </Container>

                </>
            )
        }
        else {
            return (
                <>
                    <Helmet>
                        <title>Corso non trovato</title>
                    </Helmet>

                    <Container fluid='md' className='mt-5 mb-5 text-secondary'>
                        <h3>Corso non trovato</h3>

                        {errors.length > 0 &&
                            <Alert variant='danger'>
                                {errors}
                            </Alert>
                        }

                    </Container>
                </>
            )
        }
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};